import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

// Tasks waiting for the viewer to approve going Live. Renders nothing when the
// list is empty (or the call fails), so most people never see it.
export default function PendingLiveApprovals({ refreshKey }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/live-approvals/mine").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [refreshKey]);

  if (rows.length === 0) return null;

  return (
    <div className="mb-4 border border-amber-300 bg-amber-50 rounded-sm" data-testid="pending-live-approvals">
      <div className="px-4 py-2 border-b border-amber-200 text-sm font-semibold text-amber-900">
        Waiting for your approval to go Live ({rows.length})
      </div>
      <ul className="divide-y divide-amber-200">
        {rows.map((r) => (
          <li key={r.id} className="px-4 py-2 flex items-center justify-between gap-4 text-sm">
            <div className="min-w-0">
              <Link to={`/tasks/${r.task_id}`} className="font-medium text-[#0176D3] hover:underline">
                {r.task_number ? `#${r.task_number} ` : ""}{r.task_title}
              </Link>
              <div className="text-xs text-amber-800 truncate">
                {r.project_title} · requested by {r.requested_by_name || "someone"}
              </div>
            </div>
            <Link to={`/tasks/${r.task_id}`} className="text-xs font-medium text-[#0176D3] hover:underline shrink-0">
              Review
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
